// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__14Tod","content":"styles_content__2nqTi"};